
import { Quest } from '../types';

export const QUESTS: { [id: string]: Quest } = {
    // --- Goblin Chain ---
    'goblin_menace_1': {
        id: 'goblin_menace_1',
        title: 'Goblin Menace',
        description: 'The road is being harassed by goblin scouts. Thin their numbers to make the area safer for travelers.',
        levelRequirement: 1,
        objectives: [ { type: 'kill', targetId: 'goblin_scout', requiredAmount: 3 } ],
        rewards: { xp: 50, gold: 25 },
        followUpQuestId: 'goblin_menace_2',
    },
    'goblin_menace_2': {
        id: 'goblin_menace_2',
        title: "Chief's Challenge",
        description: "With the scouts gone, their chief is furious. It's time to cut the head off the snake. Slay the Goblin Chief in the Goblin Cave.",
        levelRequirement: 2,
        objectives: [ { type: 'kill', targetId: 'goblin_chief', requiredAmount: 1 } ],
        rewards: { xp: 200, gold: 100, items: ['chiefs_cleaver'] },
        followUpQuestId: 'goblin_menace_gnolls',
    },
    'goblin_menace_gnolls': {
        id: 'goblin_menace_gnolls',
        title: "Cackling Accomplices",
        description: "The goblin chief's notes mentioned an alliance with 'cackling ones'. This must be the gnolls at their outpost. Beat some information out of them.",
        levelRequirement: 5,
        objectives: [ { type: 'kill', targetId: 'gnoll_scavenger', requiredAmount: 5 } ],
        rewards: { xp: 350, gold: 175, items: ['gnoll_bone_armor'] },
        followUpQuestId: 'goblin_menace_3',
    },
    'goblin_menace_3': {
        id: 'goblin_menace_3',
        title: "The Real Threat",
        description: "A scrap of parchment from the gnolls confirms it: they're taking orders from hobgoblins. It's time to assault the Hobgoblin Barracks and end this threat permanently.",
        levelRequirement: 8,
        objectives: [ { type: 'kill', targetId: 'hobgoblin_soldier', requiredAmount: 5 } ],
        rewards: { xp: 500, gold: 250, items: ['steel_gauntlets'] },
    },

    // --- Beast Hunter Chain ---
    'beast_hunt_1': {
        id: 'beast_hunt_1',
        title: 'A Dire Problem',
        description: 'Dire wolves are becoming increasingly bold, attacking livestock. Cull the pack in the Wolf\'s Den.',
        levelRequirement: 5,
        objectives: [ { type: 'kill', targetId: 'dire_wolf', requiredAmount: 5 } ],
        rewards: { xp: 300, gold: 150 },
        followUpQuestId: 'beast_hunt_2',
    },
    'beast_hunt_2': {
        id: 'beast_hunt_2',
        title: 'Terrifying Shriek',
        description: 'A creature of nightmare, the Owlbear, has been spotted in the woods. Hunt this abomination.',
        levelRequirement: 7,
        objectives: [ { type: 'kill', targetId: 'owlbear', requiredAmount: 1 } ],
        rewards: { xp: 450, gold: 200, items: ['trollhide_belt'] },
        followUpQuestId: 'beast_hunt_3',
    },
    'beast_hunt_3': {
        id: 'beast_hunt_3',
        title: 'Stony Gaze',
        description: 'Travelers speak of a canyon where statues of people and animals line the walls. A basilisk must be responsible. Slay it.',
        levelRequirement: 10,
        objectives: [ { type: 'kill', targetId: 'basilisk', requiredAmount: 2 } ],
        rewards: { xp: 600, gold: 300, items: ['wyvern_scale_shield'] },
        followUpQuestId: 'beast_hunt_4',
    },
    'beast_hunt_4': {
        id: 'beast_hunt_4',
        title: 'Three-Headed Terror',
        description: 'A monstrous Chimera has made its den nearby, a terrifying fusion of lion, goat, and dragon. It must be destroyed.',
        levelRequirement: 21,
        objectives: [ { type: 'kill', targetId: 'chimera', requiredAmount: 1 } ],
        rewards: { xp: 1500, gold: 750, items: ['dragonscale_armor'] },
        followUpQuestId: 'beast_hunt_5',
    },
    'beast_hunt_5': {
        id: 'beast_hunt_5',
        title: 'The Unending Hunger',
        description: 'Deep within a hidden lake lies a Hydra, its heads regenerating as soon as they are severed. This is the ultimate test for a beast hunter.',
        levelRequirement: 24,
        objectives: [ { type: 'kill', targetId: 'hydra', requiredAmount: 1 } ],
        rewards: { xp: 2500, gold: 1200, items: ['heart_of_the_phoenix'] },
    },

    // --- Undead Scourge Chain ---
    'undead_scourge_1': {
        id: 'undead_scourge_1',
        title: 'Restless Dead',
        description: 'The local graveyard is crawling with animated dead. Put the skeletons and zombies back in the ground.',
        levelRequirement: 5,
        objectives: [
            { type: 'kill', targetId: 'skeleton_archer', requiredAmount: 3 },
            { type: 'kill', targetId: 'zombie_shambler', requiredAmount: 2 },
        ],
        rewards: { xp: 350, gold: 180 },
        followUpQuestId: 'undead_scourge_2',
    },
    'undead_scourge_2': {
        id: 'undead_scourge_2',
        title: 'The Ghoul King',
        description: 'A vile Ghoul seems to be directing the lesser undead from the Haunted Graveyard. End its reign.',
        levelRequirement: 5,
        objectives: [ { type: 'kill', targetId: 'ghoul', requiredAmount: 1 } ],
        rewards: { xp: 400, gold: 200, items: ['healing_charm'] },
        followUpQuestId: 'undead_scourge_3',
    },
    'undead_scourge_3': {
        id: 'undead_scourge_3',
        title: 'Cryptic Commands',
        description: 'The ghoul was merely a puppet. A more intelligent undead, a Wight, resides in the Crypt of the Restless. Destroy it.',
        levelRequirement: 7,
        objectives: [ { type: 'kill', targetId: 'wight', requiredAmount: 2 } ],
        rewards: { xp: 550, gold: 280, items: ['blessed_warhammer'] },
        followUpQuestId: 'undead_scourge_5',
    },
    'undead_scourge_4': {
        id: 'undead_scourge_4',
        title: 'The Life-Drinker',
        description: 'An ethereal cold emanates from the Wraith Barrow. A Wraith is draining life from the area. It must be stopped.',
        levelRequirement: 18,
        objectives: [ { type: 'kill', targetId: 'wraith', requiredAmount: 1 } ],
        rewards: { xp: 1200, gold: 600, items: ['libram_of_souls'] },
    },
    'undead_scourge_5': {
        id: 'undead_scourge_5',
        title: 'Heart of the Scourge',
        description: 'The source of all this undeath is a Lich Acolyte, experimenting with souls in its study. End this madness once and for all.',
        levelRequirement: 17,
        objectives: [ { type: 'kill', targetId: 'lich_acolyte', requiredAmount: 1 } ],
        rewards: { xp: 1500, gold: 800, items: ['staff_of_the_archon'] },
        followUpQuestId: 'undead_scourge_4',
    },
    
    // --- Orcish Threat Chain ---
    'orc_threat_1': {
        id: 'orc_threat_1',
        title: 'Green Tide',
        description: 'Orc grunts from a nearby war camp are becoming a major threat. Reduce their numbers.',
        levelRequirement: 6,
        objectives: [ { type: 'kill', targetId: 'orc_grunt', requiredAmount: 5 } ],
        rewards: { xp: 400, gold: 200, items:['orcish_choppa']},
        followUpQuestId: 'orc_threat_2',
    },
    'orc_threat_2': {
        id: 'orc_threat_2',
        title: 'Big and Dumb',
        description: 'The orcs are bolstered by Ogre Brutes. Go to the Ogre Cavern and show them the error of their ways.',
        levelRequirement: 9,
        objectives: [ { type: 'kill', targetId: 'ogre_brute', requiredAmount: 2 } ],
        rewards: { xp: 500, gold: 250, items:['giants_belt']},
        followUpQuestId: 'orc_threat_3',
    },
    'orc_threat_3': {
        id: 'orc_threat_3',
        title: 'The Warlord',
        description: 'The leader of this horde is an Orc Warlord in the Orcish Citadel. His defeat should scatter them.',
        levelRequirement: 15,
        objectives: [ { type: 'kill', targetId: 'orc_warlord', requiredAmount: 1 } ],
        rewards: { xp: 1000, gold: 500, items:['greatsword_of_valor'] },
        followUpQuestId: 'orc_threat_4',
    },
    'orc_threat_4': {
        id: 'orc_threat_4',
        title: 'A Cunning Mind',
        description: 'The Warlord wasn\'t smart enough to organize this. We\'ve learned he was advised by a two-headed Ogre Mage. Find and eliminate this magical menace in its tower.',
        levelRequirement: 16,
        objectives: [ { type: 'kill', targetId: 'ogre_mage', requiredAmount: 1 } ],
        rewards: { xp: 1200, gold: 600, items:['archmage_robes'] },
    },

    // --- Elemental Chaos Chain ---
    'elemental_chaos_1': {
        id: 'elemental_chaos_1',
        title: 'Unstable Shrine',
        description: 'Lesser elementals are pouring out of a forgotten shrine. Restore the balance by pacifying them.',
        levelRequirement: 11,
        objectives: [
            { type: 'kill', targetId: 'lesser_fire_elemental', requiredAmount: 1 },
            { type: 'kill', targetId: 'lesser_water_elemental', requiredAmount: 1 },
            { type: 'kill', targetId: 'lesser_earth_elemental', requiredAmount: 1 },
        ],
        rewards: { xp: 600, gold: 300, items:['band_of_elemental_mastery'] },
        followUpQuestId: 'elemental_chaos_2',
    },
    'elemental_chaos_2': {
        id: 'elemental_chaos_2',
        title: 'Raging Inferno',
        description: 'The fire elementals are out of control. Journey to the Cinder Pit and quell the larger spirits that have manifested.',
        levelRequirement: 15,
        objectives: [ { type: 'kill', targetId: 'fire_elemental', requiredAmount: 2 } ],
        rewards: { xp: 1300, gold: 0, items:['phoenix_down_mantle'] },
        followUpQuestId: 'elemental_chaos_3',
    },
    'elemental_chaos_3': {
        id: 'elemental_chaos_3',
        title: 'Unmoving Mountain',
        description: 'The earth elementals have become aggressive, their stony bodies a threat to all. Subdue them in the Golem Foundry.',
        levelRequirement: 15,
        objectives: [ { type: 'kill', targetId: 'earth_elemental', requiredAmount: 2 } ],
        rewards: { xp: 1400, gold: 0, items:['earthshaker_maul'] },
        followUpQuestId: 'elemental_chaos_4',
    },
    'elemental_chaos_4': {
        id: 'elemental_chaos_4',
        title: 'Heart of Chaos',
        description: 'The source of the imbalance is a tear into the Plane of Elemental Chaos itself. Only a true hero can survive it.',
        levelRequirement: 35,
        objectives: [ { type: 'kill', targetId: 'chimera', requiredAmount: 1 } ],
        rewards: { xp: 4000, gold: 2000, items:['eye_of_the_maelstrom'] },
    },

    // --- Demonic Incursion Chain ---
    'demonic_incursion_1': {
        id: 'demonic_incursion_1',
        title: 'Fiendish Imps',
        description: 'A Demonic Gate has opened, and pesky Imps are causing trouble. Send them back to their plane.',
        levelRequirement: 19,
        objectives: [ { type: 'kill', targetId: 'imp', requiredAmount: 5 } ],
        rewards: { xp: 1000, gold: 400, items:['vampiric_gauntlets'] },
        followUpQuestId: 'demonic_incursion_2',
    },
    'demonic_incursion_2': {
        id: 'demonic_incursion_2',
        title: 'Siren\'s Call',
        description: 'A Succubus is luring powerful warriors to their doom near the gate. Resist her charms and end her.',
        levelRequirement: 19,
        objectives: [ { type: 'kill', targetId: 'succubus', requiredAmount: 1 } ],
        rewards: { xp: 1500, gold: 700, items:['robes_of_the_oracle'] },
        followUpQuestId: 'demonic_incursion_3',
    },
    'demonic_incursion_3': {
        id: 'demonic_incursion_3',
        title: 'The Gatekeeper',
        description: 'A powerful Horned Devil guards the Demonic Gate. Defeat it to seal the portal.',
        levelRequirement: 19,
        objectives: [ { type: 'kill', targetId: 'horned_devil', requiredAmount: 1 } ],
        rewards: { xp: 2000, gold: 1000, items:['demonsoul_edge'] },
        followUpQuestId: 'demonic_incursion_4',
    },
    'demonic_incursion_4': {
        id: 'demonic_incursion_4',
        title: 'The Lingering Evil',
        description: 'Though the main gate is closed, an Abyssal Rift remains, leaking demonic energy. Cleanse it by defeating its powerful guardians.',
        levelRequirement: 28,
        objectives: [ { type: 'kill', targetId: 'horned_devil', requiredAmount: 1 } ],
        rewards: { xp: 3000, gold: 1500, items:['shadowmourne'] },
    },

    // --- The Giant Wars Chain ---
    'giant_wars_1': {
        id: 'giant_wars_1',
        title: 'A Giant Problem',
        description: 'Hill Giants are raiding the lowlands from their encampment. Thin their numbers and slay their leader.',
        levelRequirement: 20,
        objectives: [ { type: 'kill', targetId: 'hill_giant', requiredAmount: 3 } ],
        rewards: { xp: 2500, gold: 1000, items:['helm_of_the_behemoth'] },
        followUpQuestId: 'giant_wars_2',
    },
    'giant_wars_2': {
        id: 'giant_wars_2',
        title: 'The Jotunheim Front',
        description: 'Scouts report that Frost Giants are on the move from their icy stronghold. We must mount a preemptive strike.',
        levelRequirement: 22,
        objectives: [ { type: 'kill', targetId: 'frost_giant', requiredAmount: 2 } ],
        rewards: { xp: 3000, gold: 1500, items:['orb_of_winter'] },
        followUpQuestId: 'giant_wars_3',
    },
    'giant_wars_3': {
        id: 'giant_wars_3',
        title: 'Muspelheim\'s Rage',
        description: 'To counter the frost giants, the fire giants are stoking the flames of war in their great forge. Sabotage their efforts.',
        levelRequirement: 23,
        objectives: [ { type: 'kill', targetId: 'fire_giant', requiredAmount: 2 } ],
        rewards: { xp: 3500, gold: 1800, items:['firelords_blade'] },
        followUpQuestId: 'giant_wars_4',
    },
    'giant_wars_4': {
        id: 'giant_wars_4',
        title: 'Clash of Titans',
        description: 'The eternal war between the giant clans has reached a fever pitch. Survive the battlefield known as The Giant War.',
        levelRequirement: 38,
        objectives: [
            { type: 'kill', targetId: 'frost_giant', requiredAmount: 1 },
            { type: 'kill', targetId: 'fire_giant', requiredAmount: 1 },
        ],
        rewards: { xp: 5000, gold: 2500, items:['aegis_of_the_world_forger'] },
    },

    // --- Draconic Scales Chain ---
    'draconic_scales_1': {
        id: 'draconic_scales_1',
        title: 'Wyvern Hunt',
        description: 'Wyverns are a lesser form of dragon, but no less deadly. Hunt them down on Wyvern Peak for their valuable scales.',
        levelRequirement: 17,
        objectives: [ { type: 'kill', targetId: 'wyvern', requiredAmount: 2 } ],
        rewards: { xp: 1800, gold: 800, items:['wyvern_scale_shield'] },
        followUpQuestId: 'draconic_scales_2',
    },
    'draconic_scales_2': {
        id: 'draconic_scales_2',
        title: 'The Verdant Threat',
        description: 'A young green dragon is terrorizing the region from its nursery. It is time to end its reign before it grows stronger.',
        levelRequirement: 18,
        objectives: [ { type: 'kill', targetId: 'young_green_dragon', requiredAmount: 1 } ],
        rewards: { xp: 2200, gold: 1100, items:['dragonhide_boots'] },
        followUpQuestId: 'draconic_scales_3',
    },
    'draconic_scales_3': {
        id: 'draconic_scales_3',
        title: 'The Dragon\'s Roost',
        description: 'Multiple dragons are gathering at a single peak. This is an unprecedented threat that must be scattered.',
        levelRequirement: 39,
        objectives: [ { type: 'kill', targetId: 'young_green_dragon', requiredAmount: 1 } ],
        rewards: { xp: 6000, gold: 3000, items:['thori_dal_the_stars_fury'] },
    },

    // --- The Crimson Corruption Saga ---
    'crimson_corruption_1': {
        id: 'crimson_corruption_1',
        title: 'A Strange Blight',
        description: 'Farmers complain of a strange crimson blight killing crops and livestock. Investigate the nearby fields and slay any afflicted creatures you find.',
        levelRequirement: 2,
        objectives: [{ type: 'kill', targetId: 'giant_rat', requiredAmount: 5 }],
        rewards: { xp: 100, gold: 50 },
        followUpQuestId: 'crimson_corruption_2'
    },
    'crimson_corruption_2': {
        id: 'crimson_corruption_2',
        title: 'The Source',
        description: 'The blight seems to originate from a cave nearby. It\'s not just animals; people have been seen entering, pale and glassy-eyed. Investigate the cave and look for clues.',
        levelRequirement: 4,
        objectives: [{ type: 'kill', targetId: 'cultist_acolyte', requiredAmount: 3 }],
        rewards: { xp: 200, gold: 100 },
        followUpQuestId: 'crimson_corruption_3'
    },
    'crimson_corruption_3': {
        id: 'crimson_corruption_3',
        title: 'A Dark Sermon',
        description: 'You found a crude altar and a torn page mentioning the "Crimson Dawn" and a leader. Their influence is spreading. Disrupt their operations at the Ruined Watchtower.',
        levelRequirement: 6,
        objectives: [{ type: 'kill', targetId: 'cultist_acolyte', requiredAmount: 5 }],
        rewards: { xp: 300, gold: 150, items: ['acolyte_staff'] },
        followUpQuestId: 'crimson_corruption_4'
    },
    'crimson_corruption_4': {
        id: 'crimson_corruption_4',
        title: 'Intercepted Orders',
        description: 'A courier for the Crimson Dawn was spotted heading for the Hobgoblin Barracks. Intercept them and find out what their plans are.',
        levelRequirement: 8,
        objectives: [{ type: 'kill', targetId: 'hobgoblin_soldier', requiredAmount: 1 }, { type: 'kill', targetId: 'cultist_acolyte', requiredAmount: 4 }],
        rewards: { xp: 400, gold: 200 },
        followUpQuestId: 'crimson_corruption_5'
    },
    'crimson_corruption_5': {
        id: 'crimson_corruption_5',
        title: 'Strength in Numbers',
        description: 'The orders reveal the cult is recruiting monstrous allies. They are trying to sway the ogres in the Ogre Cavern. Stop their champion from completing the ritual.',
        levelRequirement: 12,
        objectives: [{ type: 'kill', targetId: 'cultist_champion', requiredAmount: 1 }],
        rewards: { xp: 600, gold: 300, items: ['ring_of_regeneration'] },
        followUpQuestId: 'crimson_corruption_6'
    },
    'crimson_corruption_6': {
        id: 'crimson_corruption_6',
        title: 'Unholy Ground',
        description: 'The cult is desecrating the Vampire Crypt, twisting the undead to their will. Cleanse the crypt of their influence.',
        levelRequirement: 16,
        objectives: [{ type: 'kill', targetId: 'vampire_spawn', requiredAmount: 3 }, { type: 'kill', targetId: 'cultist_champion', requiredAmount: 5 }],
        rewards: { xp: 800, gold: 400 },
        followUpQuestId: 'crimson_corruption_7'
    },
    'crimson_corruption_7': {
        id: 'crimson_corruption_7',
        title: 'The High Priest',
        description: 'The leader of the local cult branch is High Priest Malak. He resides in the Giant Encampment, having swayed them to his cause. Defeat him.',
        levelRequirement: 20,
        objectives: [{ type: 'kill', targetId: 'high_priest_malak', requiredAmount: 1 }],
        rewards: { xp: 1500, gold: 750, items: ['heart_of_corruption'] },
        followUpQuestId: 'crimson_corruption_8'
    },
    'crimson_corruption_8': {
        id: 'crimson_corruption_8',
        title: 'Whispers of a Goddess',
        description: 'Malak\'s journal speaks of a "fallen goddess," Olphia, imprisoned in a place called the Weeping Chasm. The Crimson Dawn seeks to free her. We need more information. Search the Lich\'s Study for forbidden lore.',
        levelRequirement: 25,
        objectives: [{ type: 'kill', targetId: 'lich_acolyte', requiredAmount: 1 }],
        rewards: { xp: 2000, gold: 1000 },
        followUpQuestId: 'crimson_corruption_9'
    },
    'crimson_corruption_9': {
        id: 'crimson_corruption_9',
        title: 'The Weeping Chasm',
        description: 'The texts confirm it. Olphia is real, a goddess of despair sealed away by the ancients. Her prison is the Weeping Chasm, guarded by powerful elementals. Clear a path.',
        levelRequirement: 30,
        objectives: [{ type: 'kill', targetId: 'fire_elemental', requiredAmount: 3 }, { type: 'kill', targetId: 'earth_elemental', requiredAmount: 3 }],
        rewards: { xp: 2500, gold: 1250 },
        followUpQuestId: 'crimson_corruption_10'
    },
    'crimson_corruption_10': {
        id: 'crimson_corruption_10',
        title: 'First Seal: The Firelord',
        description: 'The Weeping Chasm is sealed by ancient wards. The first is protected by the Firelord Razorvane, now corrupted by Olphia\'s influence. Defeat him in his keep.',
        levelRequirement: 35,
        objectives: [{ type: 'kill', targetId: 'firelord_razorvane', requiredAmount: 1 }],
        rewards: { xp: 3000, gold: 1500 },
        followUpQuestId: 'crimson_corruption_11'
    },
    'crimson_corruption_11': {
        id: 'crimson_corruption_11',
        title: 'Second Seal: The Frost Lich',
        description: 'The second seal is in the domain of ice. The Frost Lich Koralon has fallen to the corruption. Venture into his crypt and shatter the second seal\'s corrupt protector.',
        levelRequirement: 40,
        objectives: [{ type: 'kill', targetId: 'koralon_the_frost_lich', requiredAmount: 1 }],
        rewards: { xp: 4000, gold: 2000 },
        followUpQuestId: 'crimson_corruption_12'
    },
    'crimson_corruption_12': {
        id: 'crimson_corruption_12',
        title: 'Third Seal: The Stone Titan',
        description: 'The third seal is one of earth and stone. Terragor the Stone Titan, a being of immense power, now serves Olphia. He must be brought down.',
        levelRequirement: 45,
        objectives: [{ type: 'kill', targetId: 'terragor_the_stone_titan', requiredAmount: 1 }],
        rewards: { xp: 5000, gold: 2500, items: ['world_serpent_buckle'] },
        followUpQuestId: 'crimson_corruption_13'
    },
    'crimson_corruption_13': {
        id: 'crimson_corruption_13',
        title: 'Fourth Seal: The Sky Tyrant',
        description: 'The fourth seal is protected by Aetherion, the Sky Tyrant. His domain is the storm itself. Confront him on his perch.',
        levelRequirement: 50,
        objectives: [{ type: 'kill', targetId: 'aetherion_sky_tyrant', requiredAmount: 1 }],
        rewards: { xp: 6000, gold: 3000 },
        followUpQuestId: 'crimson_corruption_14'
    },
    'crimson_corruption_14': {
        id: 'crimson_corruption_14',
        title: 'Fifth Seal: The Abyssal Horror',
        description: 'The fifth seal is hidden in the crushing depths, guarded by Malakor, the Abyssal Horror. Plumb the darkness and defeat the guardian.',
        levelRequirement: 56,
        objectives: [{ type: 'kill', targetId: 'malakor_abyssal_horror', requiredAmount: 1 }],
        rewards: { xp: 7000, gold: 3500 },
        followUpQuestId: 'crimson_corruption_15'
    },
    'crimson_corruption_15': {
        id: 'crimson_corruption_15',
        title: 'Sixth Seal: The Celestial Sentinel',
        description: 'The sixth seal is one of pure light, now twisted. The celestial sentinel Lumina has been corrupted. Face her in her celestial court.',
        levelRequirement: 62,
        objectives: [{ type: 'kill', targetId: 'lumina_celestial_sentinel', requiredAmount: 1 }],
        rewards: { xp: 8000, gold: 4000, items: ['sunfury_bow'] },
        followUpQuestId: 'crimson_corruption_16'
    },
    'crimson_corruption_16': {
        id: 'crimson_corruption_16',
        title: 'The Final Seal: The Dread King',
        description: 'The final seal is guarded by Vexor, a Dread King who willingly serves Olphia. His sanctum is a fortress of undeath. Break through and defeat him.',
        levelRequirement: 68,
        objectives: [{ type: 'kill', targetId: 'vexor_the_dread_king', requiredAmount: 1 }],
        rewards: { xp: 9000, gold: 4500 },
        followUpQuestId: 'crimson_corruption_17'
    },
    'crimson_corruption_17': {
        id: 'crimson_corruption_17',
        title: 'The Prison Weakens',
        description: 'With the seals broken, Olphia\'s power bleeds into the world, empowering her most devout followers. Hunt down the newly ascended Crimson Dawn Champions.',
        levelRequirement: 75,
        objectives: [{ type: 'kill', targetId: 'cultist_champion', requiredAmount: 10 }],
        rewards: { xp: 10000, gold: 5000 },
        followUpQuestId: 'crimson_corruption_18'
    },
    'crimson_corruption_18': {
        id: 'crimson_corruption_18',
        title: 'The Void Maw\'s Bargain',
        description: 'Olphia has made a pact with Grommash the Void Maw, offering it worlds to consume. You must defeat the insatiable beast before it can be fully unleashed.',
        levelRequirement: 82,
        objectives: [{ type: 'kill', targetId: 'grommash_the_void_maw', requiredAmount: 1 }],
        rewards: { xp: 12000, gold: 6000 },
        followUpQuestId: 'crimson_corruption_19'
    },
    'crimson_corruption_19': {
        id: 'crimson_corruption_19',
        title: 'An Army of Steel',
        description: 'Olphia\'s influence has twisted the Automaton Prime\'s logic. Shut down the Prime unit before its production lines overwhelm the world.',
        levelRequirement: 88,
        objectives: [{ type: 'kill', targetId: 'automaton_prime', requiredAmount: 1 }],
        rewards: { xp: 15000, gold: 7500, items: ['aegis_of_the_world_forger'] },
        followUpQuestId: 'crimson_corruption_20'
    },
    'crimson_corruption_20': {
        id: 'crimson_corruption_20',
        title: 'The Timeless Threat',
        description: 'Olphia seeks to erase her defeat from history by recruiting Chronos the Timeless. You must enter the Timeless Conundrum and stop Chronos from altering the past.',
        levelRequirement: 95,
        objectives: [{ type: 'kill', targetId: 'chronos_the_timeless', requiredAmount: 1 }],
        rewards: { xp: 18000, gold: 9000 },
        followUpQuestId: 'crimson_corruption_21'
    },
    'crimson_corruption_21': {
        id: 'crimson_corruption_21',
        title: 'Gathering Allies',
        description: 'The final battle looms. To stand a chance against a goddess, prove your worth by defeating three of the world\'s most powerful beings in their mythic lairs.',
        levelRequirement: 102,
        objectives: [{ type: 'kill', targetId: 'koralon_the_frost_lich', requiredAmount: 1 }, { type: 'kill', targetId: 'terragor_the_stone_titan', requiredAmount: 1 }, { type: 'kill', targetId: 'aetherion_sky_tyrant', requiredAmount: 1 }],
        rewards: { xp: 20000, gold: 10000 },
        followUpQuestId: 'crimson_corruption_22'
    },
    'crimson_corruption_22': {
        id: 'crimson_corruption_22',
        title: 'The Goddess\'s Herald',
        description: 'Olphia has emerged, but is not yet at full power. She has sent her herald, a mythic version of Lumina, to announce her return. Defeat her.',
        levelRequirement: 110,
        objectives: [{ type: 'kill', targetId: 'lumina_celestial_sentinel', requiredAmount: 1 }],
        rewards: { xp: 25000, gold: 12500, items: ['vestments_of_the_celestial'] },
        followUpQuestId: 'crimson_corruption_23'
    },
    'crimson_corruption_23': {
        id: 'crimson_corruption_23',
        title: 'Shattering the Aegis',
        description: 'Before you can harm Olphia, you must shatter her divine shield. It is powered by the mythic Automaton Prime. Defeat it to render her vulnerable.',
        levelRequirement: 118,
        objectives: [{ type: 'kill', targetId: 'automaton_prime', requiredAmount: 1 }],
        rewards: { xp: 30000, gold: 15000 },
        followUpQuestId: 'crimson_corruption_24'
    },
    'crimson_corruption_24': {
        id: 'crimson_corruption_24',
        title: 'Heart of Corruption',
        description: 'The source of Olphia\'s spreading corruption is a physical manifestation of her despair, the Mythic Abyssal Horror. Destroy it to weaken her hold.',
        levelRequirement: 125,
        objectives: [{ type: 'kill', targetId: 'malakor_abyssal_horror', requiredAmount: 1 }],
        rewards: { xp: 40000, gold: 20000 },
        followUpQuestId: 'crimson_corruption_25'
    },
    'crimson_corruption_25': {
        id: 'crimson_corruption_25',
        title: 'Godslayer',
        description: 'The time has come. All seals are broken, all her generals defeated. Olphia, the Fallen Goddess, awaits in the heart of the Weeping Chasm. End her reign of despair.',
        levelRequirement: 128,
        objectives: [{ type: 'kill', targetId: 'olphia_the_fallen_goddess', requiredAmount: 1 }],
        rewards: { xp: 100000, gold: 50000, items: ['tears_of_olphia'] }
    },

    // --- Standalone Dungeon Quests ---
    'quest_cellar_cleanup': { id: 'quest_cellar_cleanup', title: 'Cellar Cleanup', description: 'Clear the Rat-Infested Cellar.', levelRequirement: 2, objectives: [{type: 'kill', targetId: 'dire_wolf', requiredAmount: 1}], rewards: {xp:150, gold: 50, items: ['cracked_leather_gloves']}},
    'quest_tangled_woods': { id: 'quest_tangled_woods', title: 'Tangled Woods', description: 'Clear the Tangled Spider Woods.', levelRequirement: 2, objectives: [{type: 'kill', targetId: 'wild_boar', requiredAmount: 1}], rewards: {xp:160, gold: 55, items: ['splintered_shortbow']}},
    'quest_kobold_candles': { id: 'quest_kobold_candles', title: 'Candle Thieves', description: 'The kobolds stole a crate of candles. Slay their leader.', levelRequirement: 3, objectives: [{type: 'kill', targetId: 'bandit_thug', requiredAmount: 1}], rewards: {xp:200, gold: 70, items: ['kobold_pickaxe']}},
    'quest_disband_bandits': { id: 'quest_disband_bandits', title: 'Disband the Bandits', description: 'The Bandit Hideout must be cleared.', levelRequirement: 3, objectives: [{type: 'kill', targetId: 'bandit_thug', requiredAmount: 1}], rewards: {xp:210, gold: 75, items: ['thiefs_bandana']}},
    'quest_boarish_behavior': { id: 'quest_boarish_behavior', title: 'Boarish Behavior', description: 'The Overgrown Boar Pen is a menace. Slay the alpha boar.', levelRequirement: 4, objectives: [{type: 'kill', targetId: 'wild_boar', requiredAmount: 1}], rewards: {xp:250, gold: 90, items: ['battle_harness']}},
    'quest_flooded_fears': { id: 'quest_flooded_fears', title: 'Flooded Fears', description: 'A Lizardfolk shaman is causing the cave to flood. Stop him.', levelRequirement: 4, objectives: [{type: 'kill', targetId: 'lizardfolk_warrior', requiredAmount: 1}], rewards: {xp:260, gold: 95, items: ['sandals_of_the_oasis']}},
    'quest_cackling_hyenas': { id: 'quest_cackling_hyenas', title: 'Cackling Hyenas', description: 'The Gnoll Scavenger Outpost must be destroyed.', levelRequirement: 5, objectives: [{type: 'kill', targetId: 'gnoll_scavenger', requiredAmount: 1}], rewards: {xp:300, gold: 110, items: ['gnoll_bone_armor']}},
    'quest_graveyard_shift': { id: 'quest_graveyard_shift', title: 'Graveyard Shift', description: 'Put the dead of the Haunted Graveyard back to rest.', levelRequirement: 5, objectives: [{type: 'kill', targetId: 'ghoul', requiredAmount: 1}], rewards: {xp:310, gold: 115, items: ['holy_symbol']}},
    'quest_alpha_wolf': { id: 'quest_alpha_wolf', title: 'The Alpha Wolf', description: 'The Wolf\'s Den is led by a powerful bear, strangely enough. Slay it.', levelRequirement: 5, objectives: [{type: 'kill', targetId: 'grizzly_bear', requiredAmount: 1}], rewards: {xp:320, gold: 120, items: ['hunters_longbow']}},
    'quest_tower_squatters': { id: 'quest_tower_squatters', title: 'Tower Squatters', description: 'Evict the harpies from the Ruined Watchtower.', levelRequirement: 5, objectives: [{type: 'kill', targetId: 'harpy', requiredAmount: 1}], rewards: {xp:330, gold: 125, items: ['warlock_pendant']}},
    'quest_war_camp_leader': { id: 'quest_war_camp_leader', title: 'War Camp Leader', description: 'Defeat the leader of the Orcish War Camp.', levelRequirement: 6, objectives: [{type: 'kill', targetId: 'orc_grunt', requiredAmount: 1}], rewards: {xp:400, gold: 150, items: ['orcish_choppa']}},
    'quest_mound_of_misery': { id: 'quest_mound_of_misery', title: 'Mound of Misery', description: 'Destroy the creature at the heart of the Shambling Mound.', levelRequirement: 6, objectives: [{type: 'kill', targetId: 'owlbear', requiredAmount: 1}], rewards: {xp:410, gold: 155, items: ['enchanted_quiver']}},
    'quest_nest_egg': { id: 'quest_nest_egg', title: 'Nest Egg', description: 'Raid the Owlbear Nest for a rare feather.', levelRequirement: 7, objectives: [{type: 'kill', targetId: 'owlbear', requiredAmount: 1}], rewards: {xp:450, gold: 170, items: ['spider_silk_cape']}},
    'quest_crypt_keeper': { id: 'quest_crypt_keeper', title: 'The Crypt Keeper', description: 'The Wight in the Crypt of the Restless holds a powerful artifact.', levelRequirement: 7, objectives: [{type: 'kill', targetId: 'wight', requiredAmount: 1}], rewards: {xp:460, gold: 175, items: ['ring_of_protection']}},
    'quest_break_the_line': { id: 'quest_break_the_line', title: 'Break the Line', description: 'Defeat the commander of the Hobgoblin Barracks.', levelRequirement: 8, objectives: [{type: 'kill', targetId: 'hobgoblin_soldier', requiredAmount: 1}], rewards: {xp:500, gold: 190, items: ['reinforced_tower_shield']}},
    'quest_swamp_shaman': { id: 'quest_swamp_shaman', title: 'Swamp Shaman', description: 'Slay the basilisk that the Lizardfolk worship.', levelRequirement: 8, objectives: [{type: 'kill', targetId: 'basilisk', requiredAmount: 1}], rewards: {xp:510, gold: 195, items: ['serpents_eye_ring']}},
    'quest_stinger_extraction': { id: 'quest_stinger_extraction', title: 'Stinger Extraction', description: 'An alchemist needs the stinger of the alpha scorpion from the Scorpion Den.', levelRequirement: 9, objectives: [{type: 'kill', targetId: 'giant_scorpion', requiredAmount: 1}], rewards: {xp:550, gold: 210, items: ['poisoned_stiletto']}},
    'quest_crush_the_ogres': { id: 'quest_crush_the_ogres', title: 'Crush the Ogres', description: 'Slay the Ogre chieftain.', levelRequirement: 9, objectives: [{type: 'kill', targetId: 'ogre_brute', requiredAmount: 1}], rewards: {xp:560, gold: 215, items: ['barbarian_axe']}},
    'quest_trial_of_the_plains': { id: 'quest_trial_of_the_plains', title: 'Trial of the Plains', description: 'The centaur leader wishes to test your strength.', levelRequirement: 10, objectives: [{type: 'kill', targetId: 'centaur_archer', requiredAmount: 1}], rewards: {xp:600, gold: 230, items: ['runic_longbow']}},
    'quest_stone_hearted': { id: 'quest_stone_hearted', title: 'Stone Hearted', description: 'The great basilisk of the canyon must be slain.', levelRequirement: 10, objectives: [{type: 'kill', targetId: 'basilisk', requiredAmount: 1}], rewards: {xp:610, gold: 235, items: ['amulet_of_power']}},
    'quest_cairn_cleansing': { id: 'quest_cairn_cleansing', title: 'Cairn Cleansing', description: 'The lead spectre of the Whispering Cairn must be banished.', levelRequirement: 10, objectives: [{type: 'kill', targetId: 'spectre', requiredAmount: 1}], rewards: {xp:620, gold: 240, items: ['libram_of_souls']}},
    'quest_maze_master': { id: 'quest_maze_master', title: 'Master of the Maze', description: 'Slay the Minotaur.', levelRequirement: 11, objectives: [{type: 'kill', targetId: 'minotaur', requiredAmount: 1}], rewards: {xp:680, gold: 260, items: ['minotaur_labrys']}},
    'quest_elemental_containment': { id: 'quest_elemental_containment', title: 'Elemental Containment', description: 'The bound elementals in the shrine have broken free. Subdue their leader.', levelRequirement: 11, objectives: [{type: 'kill', targetId: 'lesser_fire_elemental', requiredAmount: 1}], rewards: {xp:690, gold: 265, items: ['dwarven_hammer']}},
    'quest_peak_predator': { id: 'quest_peak_predator', title: 'Peak Predator', description: 'The matriarch harpy on Harpy Peak is the real threat. Slay her.', levelRequirement: 12, objectives: [{type: 'kill', targetId: 'air_elemental', requiredAmount: 1}], rewards: {xp:750, gold: 290, items: ['stormcallers_focus']}},
    'quest_unearthing_evil': { id: 'quest_unearthing_evil', title: 'Unearthing Evil', description: 'Defeat the Mummy Lord in his tomb.', levelRequirement: 13, objectives: [{type: 'kill', targetId: 'mummy', requiredAmount: 1}], rewards: {xp:800, gold: 310, items: ['diadem_of_the_savant']}},
    'quest_bridge_troll': { id: 'quest_bridge_troll', title: 'The Bridge Troll', description: 'Remove the troll berserker from its bridge.', levelRequirement: 14, objectives: [{type: 'kill', targetId: 'troll_berserker', requiredAmount: 1}], rewards: {xp:850, gold: 330, items: ['earthshaker_maul']}},
    'quest_fall_of_the_citadel': { id: 'quest_fall_of_the_citadel', title: 'Fall of the Citadel', description: 'Slay the Orc Warlord.', levelRequirement: 15, objectives: [{type: 'kill', targetId: 'orc_warlord', requiredAmount: 1}], rewards: {xp:900, gold: 350, items: ['guardian_plate']}},
    'quest_dredge_the_temple': { id: 'quest_dredge_the_temple', title: 'Dredge the Temple', description: 'Cleanse the Sunken Temple by defeating its elemental guardian.', levelRequirement: 15, objectives: [{type: 'kill', targetId: 'water_elemental', requiredAmount: 1}], rewards: {xp:910, gold: 355, items: ['orb_of_winter']}},
    'quest_into_the_inferno': { id: 'quest_into_the_inferno', title: 'Into the Inferno', description: 'The Cinder Pit is home to a powerful fire elemental. Extinguish it.', levelRequirement: 15, objectives: [{type: 'kill', targetId: 'fire_elemental', requiredAmount: 1}], rewards: {xp:920, gold: 360, items:['phoenix_down_mantle']}},
    'quest_deactivate_the_foundry': { id: 'quest_deactivate_the_foundry', title: 'Deactivate the Foundry', description: 'Defeat the master Iron Golem of the Golem Foundry.', levelRequirement: 15, objectives: [{type: 'kill', targetId: 'iron_golem', requiredAmount: 1}], rewards: {xp:930, gold: 365, items:['titanforged_gauntlets']}},
    'quest_two_heads_one_stone': { id: 'quest_two_heads_one_stone', title: 'Two Heads, One Stone', description: 'Slay the Ogre-Mage of the tower.', levelRequirement: 16, objectives: [{type: 'kill', targetId: 'ogre_mage', requiredAmount: 1}], rewards: {xp:1100, gold: 430, items: ['archmage_robes']}},
};
